import { selectors } from 'app/services/projects';
import { useSelector } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { Column, ColumnTypes, DataTable } from 'components';
import { useTranslation } from 'react-i18next';
import { useGetProjectToolsQuery } from 'app/services/tools/api';
import DeleteTool from '../Actions/DeleteTool';
import { State } from 'constants/site';
import { useHasPermission } from 'hooks/authorization/useHasPermission';
import { User } from 'constants/user';

const Tools = () => {
  const project = useSelector(selectors.getProject);
  const canManage = useHasPermission(User.Permissions.CREATE_OR_UPDATE_PROJECTS);
  const notAllowedStates = [ State.CLOSED, State.EMAIL_SENT, State.DELETED ];

  const { data, isFetching } = useGetProjectToolsQuery(project?.Id ?? skipToken);
  const { t } = useTranslation();

  const columns: Column[] = [
    {
      key: 'Label',
      title: t('entities.tools.label'),
      type: ColumnTypes.LINK,
      hasSearch: true,
      hasSort: true,
      link: (tool: any) => `/tools/${tool.ToolId}`,
    },
    {
      key: 'QrCode',
      title: t('entities.tools.qrcode'),
      type: ColumnTypes.TEXT,
      hasSearch: true,
    },
    {
      key: 'CreatedBy',
      title: t('common.createdby'),
      type: ColumnTypes.TEXT
    },
    {
      key: 'CreatedAt',
      title: t('common.createdat'),
      type: ColumnTypes.DATETIME,
      hasSort: true,
    }
  ];

  if (project && !notAllowedStates.includes(project.State) && canManage) {
    columns.push({
      key: 'Action',
      title: t('common.action'),
      type: ColumnTypes.ACTIONS,
      actions: [
        (tool: any) => <DeleteTool projectTool={tool} /> ]
    });
  }

  return (
    <DataTable
      data={data}
      columns={columns}
      defaultSort={'CreatedAt'}
      isLoading={isFetching}
      pagination={true}
      tableKey="tools"
    />
  );
};

export default Tools;
